import axios from "axios";

export const getMarketStatus = async () => {
  const res = await axios.post(
    "https://pmsapi.infomanav.in/api/v1/dashboard/get_market_status"
  );
  return res.data.data;
};